import { Component, OnInit, Input,  Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";

@Component({
  selector: 'app-panel-filtros',
  templateUrl: './panel-filtros.component.html',
  styleUrls: ['./panel-filtros.component.scss']
})

export class PanelFiltrosComponent implements OnInit {
  @Input()  arrFiltros : any = [];
  @Input()  SYS33CON   : number;
  @Output() evCambioFiltro = new EventEmitter<any>();

  myFormGroup: FormGroup;

  constructor() { }

  ngOnInit(): void {
    this.CrearFormulario();
  }

  onSubmit(form: FormGroup) {
    this.evCambioFiltro.emit(JSON.stringify(this.myFormGroup.value));
  }

  CrearFormulario(){
    let group = {};
    if (this.arrFiltros !== undefined) {
      console.log('CrearFormulario',this.arrFiltros[0].FiltrosExpuestos);
      this.arrFiltros[0].FiltrosExpuestos.forEach((item) => {
        let valor = item.value;

        let validores = [];
        if (item.validators.required) {
          validores.push(Validators.required);

        }

        group[item.label] = new FormControl(
          { value: valor, disabled: false }, validores
        );
      });
    }
    this.myFormGroup = new FormGroup(group);
  }

  cargarCombo(evento, elemento) {
    /*
    if (elemento.ComboPrecargado == "S") {
      if (evento.term.length > 2) {
        let tiempo = Date.now();
        if (elemento.comboTime == null || (tiempo - elemento.comboTime) > 3000) {
          elemento.comboTime = tiempo;
          let formulario = this.myFormGroup.value;
          let campoDes = elemento.label.substring(0, elemento.label.length - 3);
          formulario[campoDes + 'DES'] = evento.term;
          let parametros = { LLAVES: [this.formatearFormulario(formulario)] };
          this.dataService.ConsultarWS("api/mantenimientos/ListarCombo/" + elemento.ComboClickURL, JSON.stringify(parametros)).subscribe((datos: any) => {
            elemento.options = datos.DATA;
          }, (err: any) => {

          });
        }
      }
    }
    */
  }

  formatearFormulario(form) {
    return form;
  }

}
